module.exports = __webpack_public_path__ + "workspace/static/img/renewalManagerFour.c2396e2.png";